module.exports = __webpack_public_path__ + "media/svg/youtube-28921463.svg";